import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { emailAddressAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const EmailAddress = ({ t, emailAddressValid, validateEmailAddress, emailAddressError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const emailAddress = useSelector((state) => state.app.emailAddress)

  const handleEmail = (e) => {
    try {
      let email = e.currentTarget.value.replace(/\s/g, '')
      dispatch(emailAddressAction(email))
      // validateEmailAddress(email)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validateEmailAddress(emailAddress)
  }

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          emailAddressValid === true
            ? emailAddress !== '' && 'form-group'
            : emailAddressValid === false && 'form-group ns-form-group-message-error'
        }
      >
        <strong className="control-label" htmlFor="EmailAddress">
          {t('contact_info.email_address')}
        </strong>
        <div className="help-field">{t('contact_info.your_receipt_will_be')}</div>
        {emailAddressValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(emailAddressError)}</div>
          </div>
        )}
        <input
          type="text"
          id="EmailAddress"
          className={['form-control', styles['field_width']].join(' ')}
          // onBlur={handleOnBlur}
          value={emailAddress}
          onChange={handleEmail}
          onFocus={() => SetIsFocussed(true)}
          autoComplete="off"
          maxLength="50"
        />
      </div>
    </div>
  )
}

export default withTranslation('common')(EmailAddress)
